import { Injectable } from "@angular/core";
import {
  COWING_KEY,
  COWING_PRIVATE,
  COWING_SEPARATOR,
} from "../config/app.config";
@Injectable({
  providedIn: "root",
})
export class CowingSecurityEncryptService {
  static instance: CowingSecurityEncryptService = new CowingSecurityEncryptService();
  constructor() {
    return (CowingSecurityEncryptService.instance =
      CowingSecurityEncryptService.instance || this);
  }

  decrypt(data): any {
    let originalKey = atob(atob(COWING_KEY).split(COWING_PRIVATE)[0]);
    let firstDecrypt = atob(data).split(COWING_PRIVATE)[0];
    let secondDecrypt = atob(firstDecrypt).split(COWING_SEPARATOR)[1];
    let finalDecrypt = atob(secondDecrypt).split(originalKey)[0];
    return finalDecrypt;
  }

  encrypt(data): any {
    let originalKey = atob(atob(COWING_KEY).split(COWING_PRIVATE)[0]);
    let dataToEncrypt = btoa(
      originalKey + COWING_SEPARATOR + btoa(data + originalKey)
    );
    let finalEncrypt = btoa(dataToEncrypt + COWING_PRIVATE);
    return finalEncrypt;
  }
}
